import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function FlashcardBioTopics() {
  return (
    <>

      <AllSubjectTopics  subject="biology" type="flashcard" />

    </>
  );
}

export default FlashcardBioTopics;